import type { Bonus, PreviewPage, Volume } from '../types/content';
export const volumes: Volume[] = [{
  label: 'VOLUMEN 01',
  title: 'MEDICINA TRADICIONAL CHINA: GUÍA PRÁCTICA PARA PRINCIPIANTES',
  subtitle: "",
  items: ['Conocé los principios tradicionales de Qi, Yin-Yang y los Cinco Elementos.', 'Familiarizate con los conceptos y el vocabulario básico.', 'Entendé el contexto de las prácticas que vas a encontrar en el resto del kit.'],
  result: '«Comprendo los fundamentos y sé de qué tratan estas prácticas».',
  accent: 'info'
}, {
  label: 'VOLUMEN 02',
  title: 'MANUAL PRÁCTICO DE QI GONG, AUTOMASAJE Y RESPIRACIÓN',
  subtitle: 'Aprendé las técnicas básicas con instrucciones claras para consultarlas mientras practicás.',
  items: ['Seguí secuencias introductorias de Qi Gong y movimiento suave.', 'Consultá técnicas sencillas de automasaje y respiración natural.', 'Revisá las indicaciones, los errores frecuentes y las precauciones.'],
  result: '«Tengo instrucciones claras para aprender las prácticas».',
  accent: 'primary'
}, {
  label: 'VOLUMEN 03',
  title: 'RUTINAS DIARIAS DE BIENESTAR: PROGRAMA PRÁCTICO DE 28 DÍAS',
  subtitle: 'Pasá de conocer las técnicas a tener un recorrido organizado para incorporarlas a tu rutina.',
  items: ['Seguí un programa de 28 días con actividades previamente organizadas.', 'Encontrá secuencias para la mañana, las pausas diurnas y la tarde.', 'Consultá rutinas de 5 y 10 minutos, alternativas sentadas y opciones para días ocupados.'],
  result: '«Sé qué práctica seguir cada día sin organizar todo desde cero».',
  accent: 'highlight'
}];
// Sin imágenes por ahora — agregá aquí las páginas interiores reales de los PDF.
export const previewPages: PreviewPage[] = [];
export const bonuses: Bonus[] = [{
  number: '01',
  title: 'GUÍA DE RUTINAS EXPRESS: 5, 10 Y 15 MINUTOS',
  detail: 'Encontrá prácticas preparadas para esos momentos en los que tenés poco tiempo.',
  items: ['Elegí rutinas según los minutos disponibles.', 'Encontrá opciones para la mañana, las pausas y el final del día.', 'Consultá alternativas breves sin combinar ejercicios por tu cuenta.'],
  value: '$12.000'
}, {
  number: '02',
  title: 'MANUAL DE MOVIMIENTO SUAVE Y ADAPTACIONES',
  detail: 'Consultá variantes generales para simplificar los movimientos cuando resulte apropiado.',
  items: ['Encontrá alternativas de movimiento suave y menor amplitud.', 'Consultá secuencias que se pueden realizar sentada.', 'Adaptá el ritmo y la duración a una práctica más cómoda.'],
  value: '$10.000'
}, {
  number: '03',
  title: 'PROTOCOLO NOCTURNO DE RELAJACIÓN Y DESCANSO',
  detail: 'Organizá una secuencia tranquila para cerrar el día y reservar un momento de calma antes de acostarte.',
  items: ['Seguí una secuencia nocturna de preparación corporal y atención a las sensaciones.', 'Elegí protocolos de 5, 10 o 15 minutos.', 'Consultá alternativas para los días en los que tenés menos tiempo.'],
  value: '$11.000'
}, {
  number: '04',
  title: 'ATLAS VISUAL DE AUTOMASAJE COTIDIANO',
  detail: 'Tené las técnicas organizadas por zona corporal para encontrarlas fácilmente cuando quieras consultarlas.',
  items: ['Encontrá instrucciones de automasaje para manos, dedos, muñecas y antebrazos.', 'Consultá técnicas sencillas para pies y tobillos.', 'Seguí secuencias breves de 3, 5 y 8 minutos.'],
  value: '$9.000'
}, {
  number: '05',
  title: 'GUÍA RÁPIDA DE USO SEGURO Y CONSULTA',
  detail: 'Reuní las principales precauciones en un documento pensado para consultar antes y durante las prácticas.',
  items: ['Revisá las precauciones generales de movimiento, respiración y automasaje.', 'Identificá señales para detener una actividad y situaciones que requieren orientación profesional.', 'Consultá recomendaciones generales relacionadas con lesiones, cirugías recientes y otras condiciones.'],
  value: '$10.000'
}];